import { render, staticRenderFns } from "./PortalLogs.vue?vue&type=template&id=2314c5f8&scoped=true"
import script from "./PortalLogs.vue?vue&type=script&lang=js"
export * from "./PortalLogs.vue?vue&type=script&lang=js"
import style0 from "./PortalLogs.vue?vue&type=style&index=0&id=2314c5f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2314c5f8",
  null
  
)

export default component.exports